<template>
  <div
    id="app"
    :class="shouldShowHeader ? 'pt-48 md-1:pt-80 [--nav-height:48px] md-1:[--nav-height:80px]' : '[--nav-height:0px]'"
  >
    <template v-if="shouldShowHeader">
      <SitterOnboardingNav v-if="onboardingLayout" />
      <GlobalNav v-else-if="isParent" />
      <SitterNav v-else-if="isSitter" />
      <PublicNav v-else />
    </template>
    <ContentfulBanner v-if="shouldShowBanner" :segment-event-name="'UpgradePricing_PostLogin_Banner'" />
    <div class="flex-1">
      <router-view />
    </div>
    <PoppinsCondensedFooter v-if="shouldShowFooter" />
  </div>
</template>

<script lang="ts">
import PoppinsCondensedFooter from '@/components/condensed_footer/PoppinsCondensedFooter.vue';
import ContentfulBanner from '@/components/contentful_banner/ContentfulBanner.vue';
import GlobalNav from '@/components/nav/GlobalNav.vue';
import PublicNav from '@/components/nav/PublicNav.vue';
import SitterNav from '@/components/nav/SitterNav.vue';
import SitterOnboardingNav from '@/components/navigation/SitterOnboardingNav.vue';
import { readMetaBoolean } from '@/lib/page';
import shouldShowContentfulBanner from '@/helpers/bannerDisplayLogic';

export default {
  name: 'App',
  components: {
    ContentfulBanner,
    GlobalNav,
    PoppinsCondensedFooter,
    PublicNav,
    SitterNav,
    SitterOnboardingNav,
  },
  computed: {
    isParent() {
      return this.account?.isParent() ?? false;
    },
    isSitter() {
      return this.account?.isSitter() ?? false;
    },
    shouldShowBanner() {
      return shouldShowContentfulBanner(this.account, this.$route.path);
    },
    shouldShowFooter() {
      return !this.$route.matched?.some((r) => r.meta?.shouldHideFooter);
    },
    nativeMobileApp() {
      return readMetaBoolean('native_mobile_app');
    },
    shouldShowHeader() {
      const hideFromMeta = this.$route.matched?.some((r) => r.meta?.hideMainHeader);
      return !hideFromMeta && !this.nativeMobileApp;
    },
    onboardingLayout() {
      return this.$route.matched?.some((r) => r.meta?.sitterOnboardingLayout);
    },
    account() {
      return this.$store.getters['account/getAccount'];
    },
  },
};
</script>

<style lang="scss" scoped>
#app {
  display: flex;
  flex-direction: column;
  min-height: calc(100dvh);
}
</style>
